import React from 'react';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const isFor = ["Parejas que sienten que 'ya no tienen de qué hablar'.", 'Mujeres que extrañan la complicidad y el juego.', 'Personas que quieren mejorar su relación sin ir a terapia.', 'Parejas que pasan demasiado tiempo en el celular.'];
  const isNotFor = ['Parejas en proceso de divorcio legal o separación violenta.', 'Personas que buscan un manual de manipulación.', 'Quienes no estén dispuestos a soltar el celular por 20 min.'];
  return <section className="py-20 bg-noir-bg border-b border-noir-border" data-id="element-15">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-17">
          {/* Target Audience */}
          <div className="bg-noir-card border border-noir-border p-8 rounded-sm" data-id="element-18">
            <h3 className="text-xl font-mono font-bold text-noir-text mb-6 uppercase border-b border-noir-border pb-4" data-id="element-19">
              Sujetos <span className="text-green-600" data-id="element-20">Aptos</span>
            </h3>
            <ul className="space-y-4" data-id="element-21">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-22">
                  <div className="bg-noir-bg border border-noir-border p-1 rounded-sm mr-3 mt-0.5" data-id="element-23">
                    <Check className="w-3 h-3 text-green-600" data-id="element-24" />
                  </div>
                  <span className="text-noir-muted text-sm" data-id="element-25">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not for */}
          <div className="bg-noir-card border border-noir-border p-8 rounded-sm opacity-80" data-id="element-26">
            <h3 className="text-xl font-mono font-bold text-noir-text mb-6 uppercase border-b border-noir-border pb-4" data-id="element-27">
              Sujetos <span className="text-noir-alert" data-id="element-28">No Aptos</span>
            </h3>
            <ul className="space-y-4" data-id="element-29">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-30">
                  <div className="bg-noir-bg border border-noir-border p-1 rounded-sm mr-3 mt-0.5" data-id="element-31">
                    <X className="w-3 h-3 text-noir-alert" data-id="element-32" />
                  </div>
                  <span className="text-noir-muted text-sm" data-id="element-33">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}